import { useBreakpointValue } from '@genial/utils';
import { Box, FlatList } from 'native-base';
import React from 'react';
import { StyleSheet } from 'react-native';

import { InfoItem, InfoItemProps } from '../InfoItem';

interface DetailsListProps {
  data: InfoItemProps[];
}

const style = StyleSheet.create({
  columnWrapper: {
    flex: 1,
    justifyContent: 'space-between',
  },
  gap: {
    rowGap: 16,
  },
});

export const DetailsList: React.FC<DetailsListProps> = ({ data }) => {
  const numColumns = useBreakpointValue({ base: 1, sm: 4, lg: 8 });

  return (
    <FlatList
      key={numColumns}
      style={style.gap}
      data={data}
      numColumns={numColumns}
      showsVerticalScrollIndicator={false}
      keyExtractor={(item, index) => `${item.value}-${index}`}
      {...(numColumns !== 1 && { columnWrapperStyle: style.columnWrapper })}
      renderItem={({ item }) => (
        <Box minW={'111px'}>
          <InfoItem {...item} />
        </Box>
      )}
    />
  );
};
